import React, {useState} from 'react'
import {Box} from '@mui/material'
import moment from 'moment'
import SidebarPanelContainerUi from '@ui/sidebarPanel/sidebarPanelContainerUi/SidebarPanelContainerUi'
import SidebarPanelUi from '@ui/sidebarPanel/SidebarPanelUi'
import {useAppContext} from '@context/appContext/hooks/useAppContext'
import {useQueryState} from '@hooks/query/useQueryState'
import {useMedia} from '@hooks/ui/useMedia'
import {
	useGetPassengerChartRouteQuery,
	useGetPassengerChartRoutesQuery
} from '@containers/monitoringPlatform/passengerCharts/queryHooks/usePassengerChartsQuery'
import PassengerChartsSidebar from '@containers/monitoringPlatform/passengerCharts/sidebar/PassengerChartsSidebar'
import RouteCardsOverview from '@containers/monitoringPlatform/passengerCharts/overview/RouteCardsOverview'
import RouteCharts from '@containers/monitoringPlatform/passengerCharts/route/RouteCharts'
import {DATE_FORMAT_PASSENGER_CHARTS} from '@containers/monitoringPlatform/passengerCharts/constants'

const isDesktopWidth = () =>
	typeof window !== 'undefined' && typeof window.matchMedia === 'function'
		? window.matchMedia('(min-width:1200px)').matches
		: true

const yesterday = () => moment().subtract(1, 'day').format(DATE_FORMAT_PASSENGER_CHARTS)

const PassengerCharts = () => {
	const {account} = useAppContext()
	const {isDesktop} = useMedia()
	const [showSidebar, setShowSidebar] = useState(isDesktopWidth)
	const [date, setDate] = useQueryState<string>('pcDate', yesterday())
	const [routeId, setRouteId] = useQueryState<number | null>('pcRoute', null, {
		parse: (value) => Number(value) || null
	})

	const routesQuery = useGetPassengerChartRoutesQuery(account.id, date)
	const routeQuery = useGetPassengerChartRouteQuery(account.id, routeId, date)
	const routes = routesQuery.data || []

	const onSelectRoute = (value: number | null) => {
		setRouteId(value)
		if (!isDesktop) {
			setShowSidebar(false)
		}
	}

	const onChangeDate = (value: string) => {
		setDate(value)
		setRouteId(null)
	}

	return (
		<SidebarPanelContainerUi isLoading={routesQuery.isFetching || routeQuery.isFetching}>
			<SidebarPanelUi
				showSidebar={showSidebar}
				setShowSidebar={setShowSidebar}
				buttonVariantToggleShow={'absolute'}
				mobileVariant={'drawer'}
				mobileToggleVariant={'fab'}
				desktopWidth={'260px'}
			>
				<PassengerChartsSidebar
					date={date}
					onChangeDate={onChangeDate}
					routes={routes}
					routeId={routeId}
					onSelectRoute={onSelectRoute}
					isLoading={routesQuery.isLoading}
				/>
			</SidebarPanelUi>

			<Box sx={{flex: 1, minWidth: 0, height: '100%', overflow: 'auto', p: 2}}>
				{routeId && routeQuery.data
					? <RouteCharts route={routeQuery.data} onBack={() => onSelectRoute(null)}/>
					: <RouteCardsOverview
						routes={routes}
						isLoading={routesQuery.isLoading}
						onSelectRoute={onSelectRoute}
					/>}
			</Box>
		</SidebarPanelContainerUi>
	)
}

export default PassengerCharts
